import styled from 'styled-components'

export const FilterContainer = styled.div`
  & > form {
    width: 100%;
  }
`

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  .issued-at {
    font-size: 0.9rem;
    color: #7e8299;
    margin-top: 0.25rem;
  }

  button {
    margin-top: 1em;
    background-color: #f3f3f3;
    svg {
      margin-right: 8px;
    }
    &:hover {
      background-color: #d3d3d3;
    }
  }
`

export const ReportTable = styled.table`
  width: 100%;
  table-layout: fixed;
  margin-top: 1rem;
  th,
  td {
    padding: 0.75rem;
    vertical-align: top;
    border-bottom: 1px solid #eff2f5;
    word-wrap: break-word;
  }

  th {
    font-weight: 600;
    background: #f9f9f9;
  }

  th.index-col,
  td.index-col {
    text-align: center;
    vertical-align: middle;
    width: 3rem;
  }

  tr.total-row td {
    font-weight: 600;
    background: #f3f6f9;
  }
`

export const SectionTitle = styled.h4`
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  font-weight: 600;
`

export const MenuFoodBadge = styled.span<{ personalized?: boolean }>`
  display: inline-block;
  margin: 0.15rem 0.35rem 0.15rem 0;
  padding: 0.15rem 0.45rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  color: ${({ personalized }) => (personalized ? '#166534' : '#92400e')};
  background-color: ${({ personalized }) =>
    personalized ? '#dcfce7' : '#fef3c7'};
`
